<template>
  <div class="edit-trainings part-content">
    <div v-if="profileLoadingState" class="loader"></div>
    <div v-else class="is-flex title">
      <h4 class="heading-4"> {{ labels.title }} ({{ lengthTrainings }})</h4>
      <icon-button class="is-primary-ghost-small" @click="addNewForm">
        <svg-icon slot="icon" name="plus" class="icon-plus" width="16" height="16"></svg-icon>
        <div slot="text">{{ labels.buttonAdd }}</div>
      </icon-button>
    </div>
    <card-panel
      v-for="(training, index) in trainingsListState"
      :key="index"
      :removable="true"
      :hasError="trainingsHasErrorsListState[index] && submitted"
      :trimmedHeaderName="true"
      class="card-item"
      @delete-card="deleteCard(training, index)">
      <label slot="header-name" class="is-uppercase">{{ trainingsListState[index].name || labels.training }} </label>
      <template slot="content">
        <edit-trainings-form
          ref="trainingsItem"
          :training="training"
          :index="index"
          @field-change="unsubmit"
        ></edit-trainings-form>
        <modal-dialog-delete-item
          :index="index"
          :modal-name="getModalName(index)"
          :label="labels.modalLabel"
          :toastMessage="labels.toastMessage"
          @delete="deleteTraining"
          @close="trackCloseModal"
        ></modal-dialog-delete-item>
      </template>
    </card-panel>
  </div>
</template>

<script>

import 'top20common/distribution/icons/plus';

import {some} from 'lodash';
import CardPanel from 'top20common/components/card-panel/CardPanel';
import {mapGetters} from 'vuex';

import IconButton from '@/common/IconButton';

import ModalDialogDeleteItem from '../ModalDialogDeleteItem';
import EditTrainingsForm from './EditTrainingForm';

const TRAINING_CERTIFICATE = 'training-certificate';

export default {
  mounted() {
    this.$emit('form-filled', this.trainingsHasValuesState);
  },
  data() {
    return {
      submitted: false
    };
  },
  watch: {
    trainingsHasValuesState(newValue) {
      this.$emit('form-filled', newValue);
    }
  },
  computed: {
    ...mapGetters([
      'trainingsListState',
      'profileLoadingState',
      'trainingsErrorsListState',
      'trainingsHasErrorsListState',
      'trainingsHasValuesState',
      'partHasChangesState'
    ]),
    labels() {
      return {
        title: this.$gettext('Training & certificates'),
        buttonAdd: this.$gettext('Add new'),
        training: this.$gettext('Training or certificate name'),
        modalLabel: this.$gettext('Delete this training item?'),
        toastMessage: this.$gettext('Training deleted')
      };
    },
    lengthTrainings() {
      return this.trainingsListState.length;
    }
  },
  methods: {
    addNewForm() {
      this.$store.commit('addEmptyTrainingItem');
      this.$mam.trackProfileAddNewItem(TRAINING_CERTIFICATE);
    },
    getModalName(index) {
      return `remove-modal-${index}`;
    },
    trackCloseModal() {
      this.$mam.trackProfileCancelDeleteExperienceClicked(TRAINING_CERTIFICATE);
    },
    deleteTraining(index) {
      this.$store.commit('deleteTrainingItem', index);
      this.$mam.trackProfileDeleteExperienceClicked(TRAINING_CERTIFICATE);
      this.setHasChanges(true);
    },
    deleteCard(experience, index) {
      this.$mam.trackProfileXClicked(TRAINING_CERTIFICATE);
      if (!some(Object.values(experience))) {
        return this.deleteTraining(index);
      }
      this.$modal.show(this.getModalName(index));
    },
    unsubmit() {
      this.submitted = false;
      this.setHasChanges(true);
    },
    saveTrainings(data) {
      return this.$store
        .dispatch('saveTrainingAction', data)
        .then(() => {
          this.$toast.open({message: this.$gettext('Training and certificates saved'), type: 'is-success'});
        })
        .catch(error => {
          this.$toast.open({duration: 5000, message: error, type: 'is-danger'});
        });
    },
    save() {
      return new Promise((resolve, reject) => {
        if (this.partHasChangesState.trainings) {
          this.saveTrainings([...this.trainingsListState])
            .then(resolve)
            .catch(reject);
        } else {
          resolve();
        }
        this.setHasChanges(false);
      });
    },
    hasValidationError() {
      for (let item of this.$refs['trainingsItem'] || []) {
        item.validate();
      }
      return this.trainingsHasErrorsListState.includes(true);
    },
    validate() {
      this.submitted = true;
      this.$store.dispatch('cleanTrainingsListAction');
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          if (this.hasValidationError()) {
            return reject(this.trainingsErrorsListState);
          }

          return resolve();
        });
      });
    },
    setHasChanges(value) {
      this.$store.commit('mutatePartHasChangesState', {trainings: value});
    }
  },
  components: {IconButton, EditTrainingsForm, CardPanel, ModalDialogDeleteItem}
};
</script>

<style lang="scss" scoped>
/deep/ .icon-plus.svg-icon {
  stroke: var(--secondary);
}
/deep/ .btn-item {
  color: var(--secondary);
}
.card-item {
  margin-bottom: 20px;
}
.title {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
/deep/ .button.is-primary-ghost-small {
  width: auto;
}
</style>
